import axios from 'axios';
import { BookTalkQuestionsItem, SetBookTalkBody } from '@ilteducation/exercise-service-types';

const serviceUrl = process.env.VUE_APP_EXERCISES_API_URL;

const getHeaders = () => ({
  'Content-Type': 'application/json',
});

export const fetchBookTalkQuestions = async (bookId: string): Promise<BookTalkQuestionsItem> => {
  const url = `${serviceUrl}book-talk-questions/${bookId}`;

  return axios
    .request({
      url,
      method: 'GET',
      headers: getHeaders(),
    })
    .then((response) => response.data);
};

export const setBookTalkQuestions = async (bookId: string, body: SetBookTalkBody): Promise<void> => {
  const url = `${serviceUrl}book-talk-questions/${bookId}`;

  return axios.request({
    url,
    method: 'PUT',
    headers: getHeaders(),
    data: body,
  });
};
